import { useAppAuth } from './UseAppAuth.ts'

export function useMyClub() {
  const { isAuthenticated, user, userLoaded } = useAppAuth()
  const myClub = isAuthenticated ? user?.clubs[0] : undefined
  return {
    isAuthenticated,
    userLoaded,
    myClub,
    myClubPath: myClub ? `/club/${myClub.id}` : undefined,
  }
}
